import SpriteSymbol from "../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "upload",
  "use": "upload-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"upload\"><g fill=\"none\" fill-rule=\"evenodd\"><path /><g fill=\"var(--bolt-theme-icon, currentColor)\"><path d=\"M19 19.5H5a1 1 0 000 2h14c.6 0 1-.4 1-1 0-.5-.4-1-1-1M6.7 10.7h2.6V18h5.3v-7.3h2.6c.3 0 .6-.2.7-.4l.1-.3c0-.2 0-.3-.2-.4l-5.2-6.3A.8.8 0 0012 3c-.2 0-.5.1-.6.3L6.2 9.6c-.2.2-.3.4-.1.7.1.2.4.4.6.4\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol